module.exports = __webpack_public_path__ + "static/media/logo-assurant.60199c69.svg";